import React, { createContext, useState, useEffect } from 'react';
import AuthService from '../services/AuthService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());

  const login = async (email, password) => {
    const user = await AuthService.login(email, password);
    setCurrentUser(user);
  };

  const logout = () => {
    AuthService.logout();
    setCurrentUser(null);
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    
    if (user) {
      const isTokenExpired = user.expirationTime && user.expirationTime <= Date.now();
      
      if (isTokenExpired) {
        logout();
      } else {
        // Set a timeout to log the user out when the token expires
        setTimeout(() => {
          logout();
          window.location.reload(); // Optional: to redirect to login or refresh UI
        }, user.expirationTime - Date.now());
      }
    }
    
    setCurrentUser(user);
  }, []);  

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
